import _extends from 'babel-runtime/helpers/extends';
import _noop from 'lodash/noop';
import createReactContext from 'create-react-context';


var defaultUtils = {
  toggleActive: _noop,
  goUpTo: _noop,
  adjustHeight: _noop,
  isActive: _noop,
  isLevelBelow: _noop
};

var DrawerContext = createReactContext(_extends({}, defaultUtils));

export default DrawerContext;
//# sourceMappingURL=DrawerContext.js.map